module.exports = __webpack_public_path__ + "static/media/4.15.316ae173.png";